export const constants = {
  PASSPORT_TYPES: {
    CARD_ID: 'CardId',
    INTERNATIONAL_PASSPORT: 'InternationalPassport',
    OLD_PASSPORT: 'OldPassport',
    TEMPORARY_RESIDENCE: 'TemporaryResidence',
    PERMANENT_RESIDENCE: 'PermanentResidence',
    TEMPORARY_PERMIT: 'TemporaryPermit',
    TEMPORARY_CERTIFICATE: 'TemporaryCertificate',
    ADDITIONAL_PROTECTION_CARD: 'AdditionalProtectionCard',
    FOREIGN_TEMPORARY_RESIDENCE:'ForeignTemporaryResidence',
    FOREIGN_PERMANENT_RESIDENCE: 'ForeignPermanentResidence',
    FOREIGN_CARD_ID: 'ForeignCardId',
    FOREIGN_INTERNATIONAL_PASSPORT: 'ForeignInternationalPassport',
    FOREIGN_PASSPORT: 'ForeignPassport'

  },
  RESIDENT_IMAGE_EXTENSIONS: [
    'tiff',
    'bmp',
    'jpeg',
    'png',
    'jpg',
    'pdf',
    'svg',
    'heic'
  ],
  NONRESIDENT_IMAGE_EXTENSIONS: [
    'bmp',
    'jpeg',
    'png',
    'jpg',
  ],
  BLOCKED_FILE_TYPES: [
    'exe',
    'bat',
    'scr',
    'vbs',
    'doc',
    'xls',
    'zip',
    'rar',
    'cmd',
    'sh',
    'php',
    'js',
    'vb',
    'vbscript',
    'bin',
    'tar',
    'obj',
    'dmg'
  ],
  ERROR_CODES: {
    full: 'FullDoubleProfile',
    fullSent: 'FullSentProfile',
    partial: 'PartDoubleProfile',
    block: 'OTPCodeBlock',
    wrongCode: 'OTPWrongCode',
    notFound: 'OTPCodeNotFound',
    forbidden: 'DomainIsForbidden',
    invalidPhone: 'invalidPhone',
    nonResidentNotAllowed:'NonResidentNotAllowed',
    resetPasswordTokenIsNotValid: 'ResetPasswordTokenIsNotValid',
    registrationImpossible: 'RegistrationImpossible'
  },
  CHECK_STATUSES: {
    INITIAL: 'INITIAL',
    REVIEW: 'REVIEW',
    ERRORS: 'ERRORS',
    REJECTED: 'REJECTED',
    APPROVED: 'APPROVED',
    SIGNING: 'SIGNING',
    SIGNED: 'SIGNED'

  },
  PROFILE_STATUSES: {
    FULL: 'FULL',
    PART: 'PART'
  },
  DATASOURCES: {
    SHARING: 'SHARING',
    BANKID: 'BANKID'
  },
  OTP_CODE_LIFE_IN_SECONDS: 60 * 15,
  AVAILABLE_LANGUAGES: {
    uk: 'Укр',
    en: 'Eng'
  }
}
